export default __webpack_public_path__ + "b4178782401ba5af813e6164e4ef2837.svg";